// -------------------------------------------------------------------------------------------------
// NortonLifeLock copyright header start
// ----------------------
//
// PROPRIETARY / CONFIDENTIAL.
// Use of this product is subject to license terms.
// Copyright (c) 2021 NortonLifeLock
// All rights reserved.
//
// -------------------------------------------------------------------------------------------------
// NortonLifeLock copyright header stop
// ----------------------
import styled from 'styled-components';

export const Icon = styled.svg.attrs({
  version: '1.1',
  xmlns: 'http://www.w3.org/2000/svg',
  xmlnsXlink: 'http://www.w3.org/1999/xlink',
  role: 'img',
})``;
